module.exports = __webpack_public_path__ + "img/china.7f8455b7.svg";